import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const TipsApi = createApi({
  reducerPath: 'tips',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getTips: builder.query({
      query: () => ({
        url: `/api/tip/getTips`,
        method: 'GET',
      }),
    }),
    updateTip: builder.mutation({
      query: ({ id, body }) => {
        return {
          url: `/api/tip/updateTip/${id}`,
          method: 'PUT',
          body: body,
        };
      },
    }),
    createTip: builder.mutation({
      query: body => ({
        url: `/api/tip/createTip`,
        method: 'POST',
        body: body,
      }),
    }),
    deleteTip: builder.mutation({
      query: ({ id }) => {
        return {
          url: `api/tip/deleteTip/${id}`,
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useCreateTipMutation,
  useUpdateTipMutation,
  useGetTipsQuery,
  useLazyGetTipsQuery,
  useDeleteTipMutation,
} = TipsApi;
